import { render, staticRenderFns } from "./DeptTreeTable.vue?vue&type=template&id=5c20892a&scoped=true"
import script from "./DeptTreeTable.vue?vue&type=script&lang=js"
export * from "./DeptTreeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c20892a",
  null
  
)

export default component.exports